import React, { useEffect, useState } from "react";

import Axios from "axios";
import { Marker } from "react-leaflet";
import { video } from "../Icons/icons";

export type AreaVideo = {
  description: {
    da: string;
    de: string;
    en: string;
  };
  position: {
    lat: number;
    lng: number;
  };
  title: string;
  videoUrl: string;
};

/*
 * This component displays the area videos markers on the map
 */
const AreaVideos = (props: { onClick: (guide: AreaVideo) => void }) => {
  const [videos, setVideos] = useState<AreaVideo[]>([]);

  useEffect(() => {
    Axios.get<AreaVideo[]>("https://www.limfjordsraadet.dk/data/area-videos/")
      .then((res) => {
        setVideos(res.data || []);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const videoMarkers =
    videos &&
    Array.isArray(videos) &&
    videos
      .filter((v) => v.position)
      .map((x, i) => (
        <Marker
          key={i}
          position={{ lat: x.position.lat, lng: x.position.lng }}
          onclick={() => props.onClick(x)}
          icon={video}
          zIndexOffset={0}
        />
      ));
  return <div>{videoMarkers}</div>;
};

export default AreaVideos;
